import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit
} from '@angular/core';
import { BehaviorSubject, first, Subject, take, takeUntil } from 'rxjs';
import { LgvLoanApp } from '../../../data-models/lgv-loan-application.model';
import { LoanAppPageService } from '../../../core/services/page-services/loan-app-page.service';
import { LgvLoanApplicationService } from '../../../core/services/lgv-loan-application.service';
import { LgvAuthMgrService } from '../../../core/services/lgv-auth-mgr.service';
import { LgvTSHelper, LgvUserService } from '../../../core/core.module';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router, NavigationEnd, Navigation } from '@angular/router';

@Component({
    selector: 'lgv-loan-app-pre-approval',
    templateUrl: './loan-app-pre-approval.component.html',
    styleUrls: ['./loan-app-pre-approval.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoanAppPreApprovalComponent implements OnInit {
    _timeline: LgvLoanApp.Timeline = null;
    timeline$ = new BehaviorSubject(this._timeline);
    onDestroy$ = new Subject();

    get isClient(): boolean {
        return this.lgvAuthMgrSvc.IsClient;
    }
    get isInternalUser(): boolean {
        return !this.isClient;
    }
    get loanAppId(): string {
        return this.loanAppPageSvc.loanAppId$.value;
    }

    selectedLoanApp = this.loanAppPageSvc.selectedLoanApplication$.value;
    appID = this.isClient
        ? this.loanAppPageSvc.selectedLoanApplication$.value.id
        : this.loanAppId;

    constructor(
        public loanAppPageSvc: LoanAppPageService,
        public lgvUserSvc: LgvUserService,
        public lgvAuthMgrSvc: LgvAuthMgrService,
        public lgvLoanAppService: LgvLoanApplicationService,
    ) {}

    ngOnInit(): void {
        this.loanAppPageSvc.selectedLoanApplication$
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(x => {
                x.loanTimeline.loanStatuses = x.loanTimeline.loanStatuses.sort(
                    x => x.displayOrder
                );

                this.timeline$.next(x.loanTimeline);
            });

        console.log('here',this.selectedLoanApp)
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }



    goToLoanAppPage() {
        if (this.lgvUserSvc.isPreLicensedAgent) {
            this.lgvUserSvc.showPreLicensingModal();
            return;
        }
        let link = '';
        if (!this.isClient) {
            link = `/admin/admin-view-loan-app/appId/${this.loanAppId}/-1/-1`;
        } else {
            link = `/client/loan-applications/${this.loanAppPageSvc.selectedLoanApplication$.value.id}/-1/-1`;
        }
        this.loanAppPageSvc.openEconsentDialog(link, this.appID, this.isClient);
    }

}
